import { ready, withEl, setListener } from '@front/utils';
import { DataLayer } from '@front/services/datalayer';
import { createComponent, getRef } from '@front/utils/alpine';
import prestashop from 'prestashop';

// @fractodoc
// - code de la prod : https://github.com/fractory-io/lepage/tree/master/modules/ga_datalayer/src/js
// - pdm MYD : https://docs.google.com/spreadsheets/d/14fHpjYjBqpneXWMHaWUWEwycUBEceVZ-jV1P-gqsu-g/edit?pli=1#gid=933934954

declare global {
    interface Window {
        dataLayer: any[];
        gtag: Function;
        gadl: DataLayer;
    }
}

const gadl = new DataLayer('lepage');

window.dataLayer = window.dataLayer || [];
window.gtag = gadl.push.bind(gadl);
window.gadl = gadl;

// Project specific code
ready(() => {
    const dataLayerContextEl = document.querySelector<HTMLMetaElement>('meta[name="datalayer-context"]');
    if (dataLayerContextEl == null) {
        throw 'Meta tag name="datalayer-context" not found';
    }

    gadl.setCurrencyCode(prestashop.currency.iso_code);

    // Base data coming from ga_datalayer
    const dataLayerContext = JSON.parse(dataLayerContextEl.content);
    if (dataLayerContext != null) {
        gadl.push(dataLayerContext);
    }

    // Breadcrumb
    let breadcrumb = <any>{};
    for (let i = 0; i < prestashop.breadcrumb.links.length; i++) {
        breadcrumb['breadcrumb' + (i + 1)] = prestashop.breadcrumb.links[i].title;
    }
    gadl.push(breadcrumb);

    // [Homepage] Mise en avant catégorie
    setListener('body#index .js-fractoblock-id-11 a', 'click', (event, el) => {
        let label = el?.closest('article')?.querySelector('.js-fractoblock-title')?.textContent?.trim();
        gadl.eventLab('homepage', 'catégorie vitrine', label ?? 'inconnu');
    });

    // Menu principal
    setListener('.fractomenu-dropdown a', 'click', (event, el) => {
        let mainMenuName = el?.closest('.js-fractomenu-tab')?.querySelector('.js-fractomenu-link')?.textContent?.trim();

        let submenuTitleEl = el?.closest('ul')?.previousElementSibling;
        if (!submenuTitleEl) {
            submenuTitleEl = el?.closest('div')?.querySelector('p');
        }

        let eventCategory = 'header - e-commerce';
        if ((el.parentNode as HTMLElement).tagName != 'LI') {
            eventCategory = 'header - contenu';
        }

        let submenuTitle = submenuTitleEl?.textContent?.trim();
        let linkName = el.textContent?.trim();

        let eventLabel = linkName;
        if (submenuTitle) {
            eventLabel = `${submenuTitle} - ${linkName}`;
        }

        gadl.eventLab(eventCategory, mainMenuName ?? 'inconnu', eventLabel ?? 'inconnu');
    });
    setListener('.js-fractomenu-link', 'click', (event, el) => {
        let linkName = el.textContent?.trim();
        gadl.eventLab('header - e-commerce', linkName ?? 'inconnu', linkName ?? 'inconnu');
    });

    // Menu footer
    setListener('.js-footer-menu a', 'click', (event, el) => {
        let action = el?.closest('.js-footer-menu')?.querySelector('.js-footer-menu-title')?.textContent?.trim();
        let label = el.textContent?.trim();
        gadl.eventLab('footer', action ?? 'inconnu', label ?? 'inconnu');
    });
});
